import React from 'react';
import { carleadCreationGetInitialProps, } from '@wkda/carlead-creation-components';
import {
  BaseLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
  CarleadStepCompoundCustomerCounterBuyCarConsentCustomerPopup
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadStepCompoundCustomerCounterBuyCarConsentCustomerPopup}
      content={CarleadHIWWhyChooseWkdaFaq}
      howItWorksShowCta={true}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
